import * as yup from 'yup'

import { EAgentKeys } from '~/features/agents/models'

const validationSchema = yup.object({
  [EAgentKeys.agentReferenceName]: yup
    .string()
    .required('Assistant name cannot be empty.'),
})

export default validationSchema
